import { ValueAndLabel } from "./valueAndLabel.model";

export enum Prefecture {
    Hokkaido = 1,
    Aomori,
    Iwate,
    Miyagi,
    Akita,
    Yamagata,
    Fukushima,
    Ibaraki,
    Tochigi,
    Gunma,
    Saitama,
    Chiba,
    Tokyo,
    Kanagawa,
    Niigata,
    Toyama,
    Ishikawa,
    Fukui,
    Yamanashi,
    Nagano,
    Gifu,
    Shizuoka,
    Aichi,
    Mie,
    Shiga,
    Kyoto,
    Osaka,
    Hyogo,
    Nara,
    Wakayama,
    Tottori,
    Shimane,
    Okayama,
    Hiroshima,
    Yamaguchi,
    Tokushima,
    Kagawa,
    Ehime,
    Kochi,
    Fukuoka,
    Saga,
    Nagasaki,
    Kumamoto,
    Oita,
    Miyazaki,
    Kagoshima,
    Okinawa,
    Overseas = 99
}

export const PREFECTURES: ValueAndLabel[] = [
    { id: Prefecture.Hokkaido, text: "北海道", cShipVal: "01" },
    { id: Prefecture.Aomori, text: "青森", cShipVal: "02" },
    { id: Prefecture.Iwate, text: "岩手", cShipVal: "03" },
    { id: Prefecture.Miyagi, text: "宮城", cShipVal: "04" },
    { id: Prefecture.Akita, text: "秋田", cShipVal: "05" },
    { id: Prefecture.Yamagata, text: "山形", cShipVal: "06" },
    { id: Prefecture.Fukushima, text: "福島", cShipVal: "07" },
    { id: Prefecture.Ibaraki, text: "茨城", cShipVal: "08" },
    { id: Prefecture.Tochigi, text: "栃木", cShipVal: "09" },
    { id: Prefecture.Gunma, text: "群馬", cShipVal: "10" },
    { id: Prefecture.Saitama, text: "埼玉", cShipVal: "11" },
    { id: Prefecture.Chiba, text: "千葉", cShipVal: "12" },
    { id: Prefecture.Tokyo, text: "東京", cShipVal: "13" },
    { id: Prefecture.Kanagawa, text: "神奈川", cShipVal: "14" },
    { id: Prefecture.Niigata, text: "新潟", cShipVal: "15" },
    { id: Prefecture.Toyama, text: "富山", cShipVal: "16" },
    { id: Prefecture.Ishikawa, text: "石川", cShipVal: "17" },
    { id: Prefecture.Fukui, text: "福井", cShipVal: "18" },
    { id: Prefecture.Yamanashi, text: "山梨", cShipVal: "19" },
    { id: Prefecture.Nagano, text: "長野", cShipVal: "20" },
    { id: Prefecture.Gifu, text: "岐阜", cShipVal: "21" },
    { id: Prefecture.Shizuoka, text: "静岡", cShipVal: "22" },
    { id: Prefecture.Aichi, text: "愛知", cShipVal: "23" },
    { id: Prefecture.Mie, text: "三重", cShipVal: "24" },
    { id: Prefecture.Shiga, text: "滋賀", cShipVal: "25" },
    { id: Prefecture.Kyoto, text: "京都", cShipVal: "26" },
    { id: Prefecture.Osaka, text: "大阪", cShipVal: "27" },
    { id: Prefecture.Hyogo, text: "兵庫", cShipVal: "28" },
    { id: Prefecture.Nara, text: "奈良", cShipVal: "29" },
    { id: Prefecture.Wakayama, text: "和歌山", cShipVal: "30" },
    { id: Prefecture.Tottori, text: "鳥取", cShipVal: "31" },
    { id: Prefecture.Shimane, text: "島根", cShipVal: "32" },
    { id: Prefecture.Okayama, text: "岡山", cShipVal: "33" },
    { id: Prefecture.Hiroshima, text: "広島", cShipVal: "34" },
    { id: Prefecture.Yamaguchi, text: "山口", cShipVal: "35" },
    { id: Prefecture.Tokushima, text: "徳島", cShipVal: "36" },
    { id: Prefecture.Kagawa, text: "香川", cShipVal: "37" },
    { id: Prefecture.Ehime, text: "愛媛", cShipVal: "38" },
    { id: Prefecture.Kochi, text: "高知", cShipVal: "39" },
    { id: Prefecture.Fukuoka, text: "福岡", cShipVal: "40" },
    { id: Prefecture.Saga, text: "佐賀", cShipVal: "41" },
    { id: Prefecture.Nagasaki, text: "長崎", cShipVal: "42" },
    { id: Prefecture.Kumamoto, text: "熊本", cShipVal: "43" },
    { id: Prefecture.Oita, text: "大分", cShipVal: "44" },
    { id: Prefecture.Miyazaki, text: "宮崎", cShipVal: "45" },
    { id: Prefecture.Kagoshima, text: "鹿児島", cShipVal: "46" },
    { id: Prefecture.Okinawa, text: "沖縄", cShipVal: "47" },
    { id: Prefecture.Overseas, text: "海外", cShipVal: "99" }
];

export const SMALL_POPULATION_PREFECTURES = [
    Prefecture.Hokkaido,
    Prefecture.Aomori,
    Prefecture.Iwate,
    Prefecture.Miyagi,
    Prefecture.Akita,
    Prefecture.Yamagata,
    Prefecture.Fukushima,
    Prefecture.Niigata,
    Prefecture.Toyama,
    Prefecture.Ishikawa,
    Prefecture.Fukui,
    Prefecture.Nagano,
    Prefecture.Tottori,
    Prefecture.Shimane,
    Prefecture.Okayama,
    Prefecture.Hiroshima,
    Prefecture.Yamaguchi,
    Prefecture.Tokushima,
    Prefecture.Kagawa,
    Prefecture.Ehime,
    Prefecture.Kochi,
    Prefecture.Fukuoka,
    Prefecture.Saga,
    Prefecture.Nagasaki,
    Prefecture.Kumamoto,
    Prefecture.Oita,
    Prefecture.Miyazaki,
    Prefecture.Kagoshima,
    Prefecture.Okinawa,
    Prefecture.Overseas
];

export enum PrefectureArea { // NOTE: おすすめ順で使用する
    Hokkaido = 1,
    Tohoku,
    Kanto,
    Tyubu,
    Kansai,
    Tyugoku,
    Shikoku,
    Kyusyu,
    Overseas
}

export const PrefectureAreaPartnerCondition = {
    // NOTE: 希望条件で使用する
    Hokkaido: "HOKKAIDO",
    Tohoku: "TOHOKU",
    Kanto: "KANTO",
    Hokuriku: "HOKURIKU",
    Tokai: "TOKAI",
    Chubu: "CHUBU",
    Kansai: "KANSAI",
    Chugoku: "CHUGOKU",
    Shikoku: "SHIKOKU",
    Kyushu: "KYUSHU",
    Other: "OTHER"
} as const;
export type PrefectureAreaPartnerCondition = typeof PrefectureAreaPartnerCondition[keyof typeof PrefectureAreaPartnerCondition];

export function getPrefectureNameById(id: number): string {
    return PREFECTURES.find(pref => id === pref.id).text;
}

export function covertToPrefArea(pref: Prefecture): PrefectureArea {
    switch (pref) {
        case Prefecture.Hokkaido:
            return PrefectureArea.Hokkaido;
        case Prefecture.Aomori:
        case Prefecture.Iwate:
        case Prefecture.Akita:
        case Prefecture.Miyagi:
        case Prefecture.Yamagata:
        case Prefecture.Fukushima:
            return PrefectureArea.Tohoku;
        case Prefecture.Ibaraki:
        case Prefecture.Tochigi:
        case Prefecture.Gunma:
        case Prefecture.Saitama:
        case Prefecture.Chiba:
        case Prefecture.Tokyo:
        case Prefecture.Kanagawa:
            return PrefectureArea.Kanto;
        case Prefecture.Yamanashi:
        case Prefecture.Nagano:
        case Prefecture.Niigata:
        case Prefecture.Toyama:
        case Prefecture.Ishikawa:
        case Prefecture.Fukui:
        case Prefecture.Shizuoka:
        case Prefecture.Aichi:
        case Prefecture.Gifu:
            return PrefectureArea.Tyubu;
        case Prefecture.Mie:
        case Prefecture.Shiga:
        case Prefecture.Kyoto:
        case Prefecture.Osaka:
        case Prefecture.Hyogo:
        case Prefecture.Nara:
        case Prefecture.Wakayama:
            return PrefectureArea.Kansai;
        case Prefecture.Tottori:
        case Prefecture.Shimane:
        case Prefecture.Okayama:
        case Prefecture.Hiroshima:
        case Prefecture.Yamaguchi:
            return PrefectureArea.Tyugoku;
        case Prefecture.Kagawa:
        case Prefecture.Ehime:
        case Prefecture.Tokushima:
        case Prefecture.Kochi:
            return PrefectureArea.Shikoku;
        case Prefecture.Fukuoka:
        case Prefecture.Saga:
        case Prefecture.Nagasaki:
        case Prefecture.Kumamoto:
        case Prefecture.Oita:
        case Prefecture.Miyazaki:
        case Prefecture.Kagoshima:
        case Prefecture.Okinawa:
            return PrefectureArea.Kyusyu;
        case Prefecture.Overseas:
            return PrefectureArea.Overseas;
        default:
            return null;
    }
}

export const PREFECTURE_AREAS_PARTNER_CONDITION: ValueAndLabel[] = [
    {
        id: PrefectureAreaPartnerCondition.Hokkaido,
        text: "北海道エリア",
        cShipVal: "1000"
    },
    {
        id: PrefectureAreaPartnerCondition.Tohoku,
        text: "東北エリア",
        cShipVal: "2000"
    },
    {
        id: PrefectureAreaPartnerCondition.Kanto,
        text: "関東エリア",
        cShipVal: "4000"
    },
    {
        id: PrefectureAreaPartnerCondition.Hokuriku,
        text: "北陸エリア",
        cShipVal: "3000"
    },
    {
        id: PrefectureAreaPartnerCondition.Tokai,
        text: "東海エリア",
        cShipVal: "9000"
    },
    {
        id: PrefectureAreaPartnerCondition.Chubu,
        text: "中部エリア",
        cShipVal: "6000"
    },
    {
        id: PrefectureAreaPartnerCondition.Kansai,
        text: "関西エリア",
        cShipVal: "5000"
    },
    {
        id: PrefectureAreaPartnerCondition.Chugoku,
        text: "中国エリア",
        cShipVal: "9001"
    },
    {
        id: PrefectureAreaPartnerCondition.Shikoku,
        text: "四国エリア",
        cShipVal: "7000"
    },
    {
        id: PrefectureAreaPartnerCondition.Kyushu,
        text: "九州エリア",
        cShipVal: "8000"
    },
    {
        id: PrefectureAreaPartnerCondition.Other,
        text: "その他エリア",
        cShipVal: "9999"
    }
];

export function getPrefectureAreaPartnerConditionById(
    id: string
): ValueAndLabel {
    return PREFECTURE_AREAS_PARTNER_CONDITION.find(pref => id === pref.id);
}

export function covertToPrefAreaPartnerConditionCShipVal(
    pref: Prefecture
): string {
    let prefName = "";
    // TODO FIX map
    switch (pref) {
        case Prefecture.Hokkaido:
            prefName = PrefectureAreaPartnerCondition.Hokkaido;
            break;
        case Prefecture.Aomori:
        case Prefecture.Iwate:
        case Prefecture.Miyagi:
        case Prefecture.Akita:
        case Prefecture.Yamagata:
        case Prefecture.Fukushima:
            prefName = PrefectureAreaPartnerCondition.Tohoku;
            break;
        case Prefecture.Tokyo:
        case Prefecture.Kanagawa:
        case Prefecture.Chiba:
        case Prefecture.Saitama:
        case Prefecture.Ibaraki:
        case Prefecture.Tochigi:
        case Prefecture.Gunma:
            prefName = PrefectureAreaPartnerCondition.Kanto;
            break;
        case Prefecture.Niigata:
        case Prefecture.Toyama:
        case Prefecture.Ishikawa:
        case Prefecture.Fukui:
            prefName = PrefectureAreaPartnerCondition.Hokuriku;
            break;
        case Prefecture.Gifu:
        case Prefecture.Aichi:
        case Prefecture.Mie:
            prefName = PrefectureAreaPartnerCondition.Tokai;
            break;
        case Prefecture.Yamanashi:
        case Prefecture.Nagano:
        case Prefecture.Shizuoka:
            prefName = PrefectureAreaPartnerCondition.Chubu;
            break;
        case Prefecture.Shiga:
        case Prefecture.Kyoto:
        case Prefecture.Osaka:
        case Prefecture.Hyogo:
        case Prefecture.Nara:
        case Prefecture.Wakayama:
            prefName = PrefectureAreaPartnerCondition.Kansai;
            break;
        case Prefecture.Tottori:
        case Prefecture.Shimane:
        case Prefecture.Okayama:
        case Prefecture.Hiroshima:
        case Prefecture.Yamaguchi:
            prefName = PrefectureAreaPartnerCondition.Chugoku;
            break;
        case Prefecture.Tokushima:
        case Prefecture.Kagawa:
        case Prefecture.Ehime:
        case Prefecture.Kochi:
            prefName = PrefectureAreaPartnerCondition.Shikoku;
            break;
        case Prefecture.Fukuoka:
        case Prefecture.Saga:
        case Prefecture.Nagasaki:
        case Prefecture.Kumamoto:
        case Prefecture.Oita:
        case Prefecture.Miyazaki:
        case Prefecture.Kagoshima:
        case Prefecture.Okinawa:
            prefName = PrefectureAreaPartnerCondition.Kyushu;
            break;
        case Prefecture.Overseas:
        default:
            prefName = PrefectureAreaPartnerCondition.Other; // C-shipAPIでエラーが出るのでその他にする
            break;
    }
    return PREFECTURE_AREAS_PARTNER_CONDITION.find(e => e.id === prefName)
        .cShipVal;
}
